import { render, staticRenderFns } from "./BIBadgeActionMenu.vue?vue&type=template&id=5c64c5f3"
import script from "./BIBadgeActionMenu.vue?vue&type=script&lang=js"
export * from "./BIBadgeActionMenu.vue?vue&type=script&lang=js"
import style0 from "./BIBadgeActionMenu.vue?vue&type=style&index=0&id=5c64c5f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports